import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { LocalizedDateTimeFormatKey } from '../types/localization-setting';
import { BaseLocalizedDateTimeRangeFormatPipe } from './base-localized-date-time-range-format.pipe';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'localizedMonthYearRangeFormat',
  standalone: true,
})
export class LocalizedMonthYearRangeFormatPipe
  extends BaseLocalizedDateTimeRangeFormatPipe
  implements PipeTransform
{
  protected readonly formatType: LocalizedDateTimeFormatKey = 'monthYearFormat';
}
